module.exports = __webpack_public_path__ + "img/qrcodeFor.1355f503.jpg";